import { forwardRef } from 'react';

/** Label + control + error, shared by every form in the app. */
export const Field = ({ label, htmlFor, required, error, hint, children }) => (
  <div className={error ? 'field field--error' : 'field'}>
    {label ? (
      <label className="field__label" htmlFor={htmlFor}>
        {label}
        {required ? <span className="field__required"> *</span> : null}
      </label>
    ) : null}
    {children}
    {hint && !error ? <p className="field__hint">{hint}</p> : null}
    {error ? <p className="field__error">{error}</p> : null}
  </div>
);

export const TextInput = ({ id, value, onChange, type = 'text', ...rest }) => (
  <input
    id={id}
    className="input"
    type={type}
    value={value ?? ''}
    onChange={(event) => onChange(event.target.value)}
    {...rest}
  />
);

/**
 * Forwards its ref, because the formatting toolbar has to reach the textarea to
 * wrap whatever the writer selected.
 */
export const TextArea = forwardRef(({ id, value, onChange, rows = 4, ...rest }, ref) => (
  <textarea
    ref={ref}
    id={id}
    className="input input--textarea"
    rows={rows}
    value={value ?? ''}
    onChange={(event) => onChange(event.target.value)}
    {...rest}
  />
));
TextArea.displayName = 'TextArea';

export const Select = ({ id, value, onChange, options, placeholder, ...rest }) => (
  <select id={id} className="input" value={value ?? ''} onChange={(event) => onChange(event.target.value)} {...rest}>
    {placeholder !== undefined ? <option value="">{placeholder}</option> : null}
    {options.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
);

export default Field;
